import React, { useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { observer } from 'mobx-react';
import { CreditCardType } from '../../../../payment/domain/models';
import { IMicroform } from '../../../../shared/api/cybersource/createFlexMicroform';
import { PaymentContextProvider } from '../../booking-steps/payment/PaymentContext';
import { NewCardForApp } from '../../booking-steps/app/NewCardForApp';
import { useNewCardForm } from '../../booking-steps/payment/helpers/useNewCardForm';
import { useHideChatBot } from '../../../../chatbot/helpers/useHideChatBot';
import Head from 'next/head';

export const NewBookingPaymentPageForApp = observer(() => {
	useHideChatBot('mobile');
	const form = useNewCardForm();
	const [newCard, setNewCard] = useState(true);
	const [newCardType, setNewCardType] = useState<CreditCardType>();
	const [isNewCardNumberValid, setIsNewCardNumberValid] = useState<boolean>();
	const [isNewCardCVVValid, setIsNewCardCVVValid] = useState<boolean>();
	const [microformInstance, setMicroformInstance] = useState<IMicroform>();
	const [storeCard, setStoreCard] = useState<boolean>(false);
	return (
		<>
			<Head>
				<title>Booking - App Payment Page</title>
			</Head>
			<PaymentContextProvider
				value={{
					newCard,
					setNewCard,
					newCardType,
					setNewCardType,
					isNewCardNumberValid,
					setIsNewCardNumberValid,
					isNewCardCVVValid,
					setIsNewCardCVVValid,
					setMicroformInstance,
					microformInstance,
					storeCard,
					setStoreCard,
				}}
			>
				<FormProvider {...form}>
					<NewCardForApp />
				</FormProvider>
			</PaymentContextProvider>
		</>
	);
});
